'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
# BriefcaseSVG
An SVG briefcase icon
 */
var BriefcaseSVG = function BriefcaseSVG(_ref) {
  var _ref$height = _ref.height,
      height = _ref$height === undefined ? undefined : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? undefined : _ref$width,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? undefined : _ref$color;
  return _react2.default.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      x: '0px',
      y: '0px',
      viewBox: '0 0 513 418',
      'aria-label': 'Briefcase',
      role: 'img',
      height: height || undefined,
      width: width || undefined
    },
    _react2.default.createElement(
      'title',
      null,
      'Briefcase'
    ),
    _react2.default.createElement(
      'desc',
      null,
      'An SVG briefcase icon'
    ),
    _react2.default.createElement(
      'g',
      {
        stroke: 'none',
        strokeWidth: '1',
        fillRule: 'evenodd'
      },
      _react2.default.createElement(
        'g',
        {
          fill: color,
          fillRule: 'nonzero'
        },
        _react2.default.createElement('path', {
          d: 'M0.5,265 C0.5,200 0.5,135 0.5,70 C56.1,70 111.6,70 167.5,70 C167.5,46.3 167.5,23.1 167.5,0 C226.8,0 286.2,0 345.5,0 C345.5,23.3 345.5,46.5 345.5,70 C401.6,70 457.1,70 512.5,70 C512.5,135 512.5,200 512.5,265 C449.6,265 386.7,265 323.3,265 C323.3,254.9 323.3,245.5 323.3,236.2 C278.8,236.2 234.9,236.2 190.4,236.2 C190.4,245.8 190.4,255.2 190.4,265 C126.7,265 63.6,265 0.5,265 Z M197.6,69.8 C237.1,69.8 276.1,69.8 315.2,69.8 C315.2,56.1 315.2,42.7 315.2,29.3 C275.8,29.3 236.8,29.3 197.6,29.3 C197.6,42.9 197.6,56.1 197.6,69.8 Z'
        }),
        _react2.default.createElement('path', {
          d: 'M512.5,296 C512.5,318.7 512.5,341.3 512.5,364 C512.2,364.9 511.7,365.8 511.5,366.8 C507.4,388.2 495.3,403.5 475.8,412.8 C471.2,415 466.3,416.3 461.5,418 C324.8,418 188.2,418 51.5,418 C49.8,417.4 48.2,416.7 46.4,416.2 C30.5,411.7 17.8,402.6 9.8,388.3 C5.6,380.8 3.5,372.1 0.5,363.9 C0.5,341.2 0.5,318.6 0.5,295.9 C63.7,295.9 127,295.9 190.7,295.9 C190.7,309 190.7,321.4 190.7,333.7 C235.2,333.7 279.1,333.7 323.6,333.7 C323.6,321.1 323.6,308.7 323.6,295.9 C386.9,296 449.7,296 512.5,296 Z'
        }),
        _react2.default.createElement('path', {
          d: 'M220.6,303.4 C220.6,291.1 220.6,279.1 220.6,266.8 C244.4,266.8 268.1,266.8 292.1,266.8 C292.1,278.9 292.1,291 292.1,303.4 C268.5,303.4 244.8,303.4 220.6,303.4 Z'
        })
      )
    )
  );
};

BriefcaseSVG.propTypes = {
  /** height for the SVG. Can be px, rem, percentage, etc. */
  height: _propTypes2.default.string,
  /** width for the SVG. Can be px, rem, percentage, etc. */
  width: _propTypes2.default.string,
  /** a color for the icon */
  color: _propTypes2.default.string
};

BriefcaseSVG.displayName = 'BriefcaseSVG';

exports.default = BriefcaseSVG;
BriefcaseSVG.__docgenInfo = {
  'description': '# BriefcaseSVG\r\nAn SVG briefcase icon',
  'methods': [],
  'displayName': 'BriefcaseSVG',
  'props': {
    'height': {
      'defaultValue': {
        'value': 'undefined',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'height for the SVG. Can be px, rem, percentage, etc.'
    },
    'width': {
      'defaultValue': {
        'value': 'undefined',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'width for the SVG. Can be px, rem, percentage, etc.'
    },
    'color': {
      'defaultValue': {
        'value': 'undefined',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'a color for the icon'
    }
  }
};